import { useState } from "react";
import { translate } from "../../../../../common/providers";

export const useConfirmationDialog = () => {
	const [confirmationDialog, setConfirmationDialog] = useState({
		open: false,
		type: null,
		title: "",
		message: "",
		onConfirm: null,
	});

	const showConfirmationDialog = (type, onConfirm) => {
		let title;
		let message;

		if (type === "change-source-phase") {
			title = translate("common.attention");
			message = translate("project-phases.strategy-import.change-source-phase-warning");
		} else {
			title = translate("common.confirm");
			message = translate("common.confirm-action");
		}

		setConfirmationDialog({
			open: true,
			type,
			title,
			message,
			onConfirm,
		});
	};

	const closeConfirmationDialog = () => {
		setConfirmationDialog({
			open: false,
			type: null,
			title: "",
			message: "",
			onConfirm: null,
		});
	};

	const handleConfirmAction = () => {
		if (confirmationDialog.onConfirm) {
			confirmationDialog.onConfirm();
		}
		closeConfirmationDialog();
	};

	return {
		confirmationDialog,
		showConfirmationDialog,
		closeConfirmationDialog,
		handleConfirmAction,
	};
};
